var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.countdownColour},[_vm._v("\n  "+_vm._s(_vm._f("countdownshortformat")(_vm.mixin_time))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }